import { IDB_WORKS } from '#pplx/frontend/browser-storage/indexedDB.js';
import { getEncryptedQueryCacheValue } from '#pplx/frontend/react-query/encryptedQueryCache.js';
import { HYDRATED_UPDATED_AT } from '#pplx/frontend/react-query/internal/consts.js';
import { getQueryCacheStore } from '#pplx/frontend/react-query/queryCacheStore.js';
import { del } from 'idb-keyval';
import { noop } from 'lodash-es';
export function hydrateQueryFromPersistedCache({ queryClient, queryKey, persistKey, }) {
    // ReactQuery doesn't have data yet if it's undefined--null is a tried
    // and got nothing state
    if (queryClient.getQueryData(queryKey) === undefined) {
        // intentionally run away — gate on IDB_WORKS so we never touch
        // IndexedDB if the backing store can't be opened
        void IDB_WORKS.then((works) => {
            if (!works || queryClient.getQueryData(queryKey) !== undefined)
                return;
            getEncryptedQueryCacheValue(persistKey, getQueryCacheStore())
                .catch(noop)
                .then((data) => {
                // No react-query data yet, but we have data from IDB--use it
                // and when the original queryFn completes, it will overwrite
                if (data && queryClient.getQueryData(queryKey) === undefined)
                    queryClient.setQueryData(queryKey, data, {
                        updatedAt: HYDRATED_UPDATED_AT,
                    });
            });
        });
    }
}
export function removePersistedQueryCacheEntry({ persistKey, }) {
    void IDB_WORKS.then((works) => {
        if (works)
            del(persistKey, getQueryCacheStore()).catch(noop);
    }); // intentionally run away
}
//# sourceMappingURL=persistedQueryCache.js.map